/**
 * Edited by libaiqi on 2018/10/25.
 * Created by han.xie on 2017/7/20.
 */
import Logic from '../logic-base'

const alarmSubscribeBiz = new Logic()

alarmSubscribeBiz.addSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addSubscribe,
    data: data
  })
}

alarmSubscribeBiz.addUser = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addUserInfo,
    data: data
  })
}

alarmSubscribeBiz.addGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addGroup,
    data: data
  })
}

alarmSubscribeBiz.getGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getGroup,
    data: data
  })
}

alarmSubscribeBiz.getAlarmList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getAlarmList,
    data: data
  })
}

alarmSubscribeBiz.deleteAlarm = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteSubscribe,
    data: data
  })
}

alarmSubscribeBiz.deleteGroups = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteGroups,
    data: data
  })
}

alarmSubscribeBiz.amendSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.saveSubscribe,
    data: data
  })
}

alarmSubscribeBiz.getKpiKey = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getKpi,
    data: data
  })
}

alarmSubscribeBiz.getIP = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getIP,
    data: data
  })
}
export default alarmSubscribeBiz
